import axios from '@/http/axios';

export default {
  fetch: (oid, config: any = {}) => {
    return axios.get(`/risk-profiles/${oid}`, config);
  },
  create: (config: any = {}) => {
    return axios.post(`/risk-profiles`, config);
  },
  createForPreview: (config: any = {}) => {
    return axios.post(`/risk-profiles/preview`, config);
  },
  updateForPreview: (oid, config: any = {}) => {
    return axios.put(`/risk-profiles/preview/${oid}`, config);
  },
  update: (oid, config: any = {}) => {
    return axios.put(`/risk-profiles/${oid}`, config);
  },
  deleteForPreview: (oid, config: any = {}) => {
    return axios.delete(`/risk-profiles/preview/${oid}`, config);
  },
  delete: (oid, config: any = {}) => {
    return axios.delete(`/risk-profiles/${oid}`, config);
  },
  fetchList: (config: any = {}) => {
    return axios.get(`/risk-profiles`, config);
  },
  fetchFullStructure: (oid, config: any = {}) => {
    return axios.get(`/risk-profiles/${oid}/full-structure`, config);
  },
  verifyName: (config: any = {}) => {
    return axios.get(`/risk-profiles/verify-name`, config);
  },
  preFetchGHC: (config: any = {}) => {
    return axios.get(`/risk-profiles/pre-fetch-ghc`, config);
  },
  duplicate: (oid, config: any = {}) => {
    return axios.post(`/risk-profiles/${oid}/duplicate`, config);
  },
};
